import { IGridServerSideDatasource, toQuery, IServerSideGetRowsParams } from '@samc/centricity-core';
import { AjaxHelper, IPaginatedList } from '@samc/common';
import { IAutosaveNotificationResponse } from './../Interfaces';

export class AutosaveNotificationDataSource implements IGridServerSideDatasource {
  public pageSize: number = 500;
  public cacheSize: number = 500;
  public adhocFilter: string = '';
  private _rowCount: number = 0;
  private _queryParams: any = {};
  private _isNotificationPopUp: boolean = false;
  readonly  _maxAutosaveCountinNotification = 15;

  public constructor(pageSize: number = 500, isNotificationPopUp: boolean = false) {
    this._isNotificationPopUp = isNotificationPopUp;
    this._rowCount = 0;
    this.pageSize = pageSize;
  }

  public async getRows(params: IServerSideGetRowsParams) {
    try {
      const helper = new AjaxHelper('', null, null, null);
      this._queryParams = toQuery(params);
      if (this._isNotificationPopUp && this._queryParams['page[number]'] !== 1) {
        params.success({ rowData: [], rowCount: this._maxAutosaveCountinNotification });
      }
      const result = await helper.getData<IPaginatedList<IAutosaveNotificationResponse>>(`/configApi/v1/autosavenotifications/list`, this._queryParams);
      this._rowCount = this._isNotificationPopUp ? (result.fullCount > this._maxAutosaveCountinNotification ? this._maxAutosaveCountinNotification : result.fullCount) : result.fullCount;
      params.success({ rowData: result.items, rowCount: this._rowCount });
    } catch (err: any) {
      params.fail();
    }
  }
}